"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));

// Libraries
var _default = {
  // TODO
  getString: function getString(string) {
    return '';
  },
  setString: function setString(string) {
    return (0, _copyToClipboard["default"])(string);
  }
};
exports["default"] = _default;